<template>
  <div class="banner-page relative-section image-fit" v-if="campingDetail && campingDetail.acf">
    <img v-if="campingDetail.acf.cam_banner" :src="campingDetail.acf.cam_banner" alt />

    <img v-if="!campingDetail.acf.cam_banner" src="../assets/images/campingbanner.jpg" alt />
    <div class="des">
      <div class="container">
        <h1 class="font-bold" v-html="campingDetail.title.rendered"></h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "lodash";
export default {
  name: "CampingBanner",
  computed: {
    ...mapState({
      campingDetail: state => get(state, "campingClubs.detail", {})
    })
  }
};
</script>
